"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientApplication = exports.BrandId = exports.Id = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const entity_1 = require("../entity");
const tenant_1 = require("./tenant");
exports.NAMESPACE = 'Culligan.ClientApplication';
exports.Id = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.Id`,
});
exports.BrandId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.BrandId`,
    description: 'A machine-readable identifier, often used to load static assets such as images or language files.',
});
exports.ClientApplication = effect_1.Schema.Struct({
    id: exports.Id,
    name: effect_1.Schema.NonEmptyString,
    brandId: exports.BrandId,
    tenantId: effect_1.Schema.optionalWith(tenant_1.Id, { exact: true, default: () => tenant_1.ROOT_TENANT_ID }).annotations({
        description: 'The Tenant this application belongs to. Omitted on records persisted before this field existed; treat as the root tenant. Domain decode fills that default.',
    }),
    enabled: effect_1.Schema.Boolean,
    createdAt: entity_1.CreatedAt,
    updatedAt: entity_1.UpdatedAt,
}).annotations({
    identifier: `${exports.NAMESPACE}.ClientApplication`,
});
//# sourceMappingURL=client-application.js.map